import { Row } from '@sdbn/common';
import { ColumnType } from '@sdbn/common';
import { SelectionType } from '@sdbn/common';
import { TmcTableModel } from '@sdbn/common';
import { TransportAttachDetachService } from './../../service/transport-attach-detach.service';
import { AttachDetachStepperModel } from '../../model/attach-detach-step-model';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { TruckDetails } from '../../model/visit-details';
import { TransportAttachDetachStepperService } from '../../service/transport-attach-detach-stepper.service';

@Component({
    selector: 'app-select-trailer-swap-target',
    templateUrl: './select-trailer-swap-target.component.html',
    styleUrls: ['./select-trailer-swap-target.component.scss'],
    standalone: false
})
export class SelectTrailerSwapTargetComponent implements OnInit, AfterViewInit {

  stepperModel: AttachDetachStepperModel;

  tableModel: TmcTableModel = new TmcTableModel();

  constructor(
    private tsmService: TransportAttachDetachService,
    private stepperService: TransportAttachDetachStepperService
  ) {

    this.stepperModel = this.stepperService.stepperModel;

    this.tableModel.selectionType = SelectionType.SINGLE;
    this.tableModel.sortable = false;
    this.tableModel.filterable = false;

    const prefix = 'tmc-yard.ui.transport.attach-detach.dialog.table.trucks.column.';
    this.tableModel.columnDefinitions = [
      { id: 'trailerIdentifier', name: 'trailerIdentifier', visible: true, type: ColumnType.STRING, translationKey: prefix + 'trailerIdentifier' },
      { id: 'stationName', name: 'stationName', visible: true, type: ColumnType.STRING, translationKey: prefix + 'station-name' },
      { id: 'carrier', name: 'carrier', visible: true, type: ColumnType.STRING, translationKey: prefix + 'carrier' },
      { id: 'supplier', name: 'supplier', visible: true, type: ColumnType.STRING, translationKey: prefix + 'supplier' },
      { id: 'registration', name: 'registration', visible: true, type: ColumnType.STRING, translationKey: prefix + 'registration' },
      {
        id: 'registrationSortValue', name: 'registrationSortValue',
        visible: false, type: ColumnType.STRING, translationKey: prefix + 'registrationSortValue'
      },
    ];

    // hook to enable/disable next button
    this.stepperModel.stepCompleted = () => {
      return this.tableModel.selectedRows.length === 1;
    };

    this.stepperModel.getNextStepIndex = () => {
      return AttachDetachStepperModel.STEP_TRAILER_SWAP_SOURCE_DETAILS;
    };

    this.stepperModel.getPreviousStepIndex = () => {
      return 0;
    };

    this.stepperModel.beforeNextStep = () => {
      return true;
    };
  }

  ngOnInit() {
    this.tsmService.getTargetsForTrailerSwap().subscribe(result => {
      this.tableModel.setRows(this.convertToTableRows(result));
    }, error => {
      console.log('Error loading current visits', error);
    });
  }

  ngAfterViewInit() {

  }

  private convertToTableRows(details: TruckDetails[]): Row[] {
    const rows: Row[] = [];
    for (const d of details) {
      const row: Row = new Row();
      row.id = d.truckId + '';
      row.values = {
        id: d.truckId,
        stationName: d.stationName,
        trailerIdentifier: d.trailerIdentifier,
        numberPlate: d.numberPlate,
        driver: d.driver,
        coDriver: d.coDriver,
        carrier: d.carrier,
        supplier: d.supplier,
        registration: d.registration,
        registrationSortValue: d.registrationSortValue,
        transportScope : d.transportScope
      };
      rows.push(row);
    }
    return rows;
  }

  onSelectionChanged(rows: Row[]) {
    if (rows && rows.length === 1) {
      this.stepperModel.workingData.trailerSwapTargetId = + rows[0].id;
      this.stepperModel.workingData.targetTransportScope = rows[0].values.transportScope;
    } else {
      this.stepperModel.workingData.trailerSwapTargetId = null;
      this.stepperModel.workingData.targetTransportScope = null;
    }
  }
}
